import {RolesEnum} from "../../modules/general/users/core/enums/roles.enum";
import {FunctionalType} from "../types/functional.type";

export const HiddenFunctionalByRoles: Record<RolesEnum, FunctionalType[]> = {
    [RolesEnum.superAdmin]: [

    ],
    // Супер-менеджер — старшая роль админки, скрывать от него нечего
    [RolesEnum.superManager]: [

    ],
    // Менеджеру оставлены только Alpaca, Модерация, Пользователи и Ручная AML-проверка —
    // так было до перехода на роли, когда меню резалось по флагу is_super_manager.
    [RolesEnum.manager]: [
        // разделы
        'strategies-list',
        'requests-list',
        'transactions',
        'commissions',
        'client-trade-trading',
        'client-trade-groups',
        'signals',
        'emergency-messages',
        'tariffs-list',
        'tariffs-groups',
        'feature-sets',
        'analytics',
        'collections-list',
        'permissions-list',
        'mobile-versions',
        'duty-manager',
        // действия внутри разделов
        'add-ticker',
        'send-push',
        'sync-orders',
        'create-tariff',
        'create-tariff-group',
        'create-feature-set',
        'create-collection',
        'create-strategy',
        'save-strategy',
        'deactivate-strategy',
        'approve-request',
        'reject-request',
        'disable-user-strategy',
        'update-tariff',
        'delete-tariff',
        'save-tariff-group',
        'delete-tariff-group',
        'save-feature-set',
        'delete-feature-set',
        'save-collection',
        'delete-collection',
    ],
    // Маркетинг — только отправка push-уведомлений, всё остальное скрыто
    [RolesEnum.marketing]: [
        'errors-list',
        'error-detail',
        'bids-list',
        'create-error',
        'bid-detail',
        'users-list',
        'add-ticker',
        'sync-orders',
        'user-summary',
        'user-profile',
        'user-anketa',
        'user-docs',
        'user-signatures',
        'user-banks',
        'user-affiliate-program',
        'user-assets',
        'create-order',
        'user-blocking',
        'users-manual-aml-check-list',
        'transactions',
        'commissions',
        'client-trade-trading',
        'client-trade-groups',
        'tariffs-list',
        'tariffs-groups',
        'feature-sets',
        'analytics',
        'collections-list',
        'permissions-list',
        'mobile-versions',
        'duty-manager',
        'create-tariff',
        'create-tariff-group',
        'create-feature-set',
        'create-collection',
        'create-strategy',
        'update-tariff',
        'delete-tariff',
        'save-tariff-group',
        'delete-tariff-group',
        'save-feature-set',
        'delete-feature-set',
        'save-collection',
        'delete-collection',
        'strategies-list',
        'requests-list',
        'emergency-messages',
        'signals',
        'save-strategy',
        'deactivate-strategy',
        'approve-request',
        'reject-request',
        'disable-user-strategy',
    ],
}
